
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function AllProductsSection() {
  const [activeCategory, setActiveCategory] = useState('全部产品');
  const [sortBy, setSortBy] = useState('default');

  const categories = ['全部产品', '普洱生茶', '普洱熟茶', '六堡茶', '珍藏系列'];
  const sortOptions = [
    { value: 'default', label: '默认排序' },
    { value: 'price-low', label: '价格从低到高' },
    { value: 'price-high', label: '价格从高到低' },
    { value: 'newest', label: '最新上架' },
    { value: 'popular', label: '最受欢迎' }
  ];

  const products = [
    {
      id: 1,
      name: '糯香小圆片熟茶',
      category: '普洱熟茶',
      price: 298,
      originalPrice: 358,
      image: 'https://public.readdy.ai/ai/img_res/487d483209c652f55040d7f2f5c88eb7.jpg',
      rating: 4.8,
      sales: 1268,
      tags: ['热销', '新品'],
      description: '精选勐海优质茶叶，糯香浓郁，口感醇厚'
    },
    {
      id: 2,
      name: '丑甜砖',
      category: '普洱熟茶',
      price: 186,
      originalPrice: 218,
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20pu-erh%20tea%20brick%20with%20unique%20rustic%20appearance%2C%20aged%20tea%20brick%20with%20natural%20patina%2C%20traditional%20tea%20packaging%2C%20warm%20golden%20lighting%2C%20premium%20tea%20presentation%20on%20elegant%20surface%2C%20simple%20clean%20background&width=400&height=400&seq=product-2&orientation=squarish',
      rating: 4.7,
      sales: 856,
      tags: ['经典'],
      description: '外形朴实内在丰富，甜润回甘，性价比极高'
    },
    {
      id: 3,
      name: '顺泰味（2008年）',
      category: '珍藏系列',
      price: 1288,
      originalPrice: 1480,
      image: 'https://readdy.ai/api/search-image?query=Vintage%202008%20aged%20pu-erh%20tea%20collection%2C%20premium%20tea%20cakes%20with%20aged%20patina%2C%20luxury%20tea%20packaging%20with%20vintage%20design%2C%20sophisticated%20presentation%2C%20warm%20lighting%20showcasing%20the%20aged%20tea%20quality%2C%20simple%20elegant%20background&width=400&height=400&seq=product-3&orientation=squarish',
      rating: 4.9,
      sales: 324,
      tags: ['珍藏', '限量'],
      description: '2008年珍藏版，十五年自然陈化，口感层次丰富'
    },
    {
      id: 4,
      name: '七星茶王六堡茶',
      category: '六堡茶',
      price: 688,
      originalPrice: 798,
      image: 'https://readdy.ai/api/search-image?query=Premium%20Liu%20Bao%20tea%20with%20seven-star%20quality%20grade%2C%20traditional%20Chinese%20dark%20tea%20presentation%2C%20elegant%20tea%20packaging%2C%20sophisticated%20arrangement%2C%20warm%20golden%20lighting%2C%20luxury%20tea%20display%2C%20simple%20clean%20background%20highlighting%20the%20tea&width=400&height=400&seq=product-4&orientation=squarish',
      rating: 4.8,
      sales: 542,
      tags: ['获奖'],
      description: '七星级茶王品质，醇厚甘甜，回味悠长'
    },
    {
      id: 5,
      name: '金芽普洱生茶',
      category: '普洱生茶',
      price: 458,
      originalPrice: 528,
      image: 'https://readdy.ai/api/search-image?query=Premium%20golden%20bud%20pu-erh%20raw%20tea%2C%20beautiful%20golden%20tea%20leaves%2C%20elegant%20tea%20cake%20presentation%2C%20traditional%20Chinese%20tea%20packaging%2C%20warm%20lighting%2C%20luxury%20tea%20display%2C%20simple%20clean%20background%20showcasing%20the%20golden%20tea%20buds&width=400&height=400&seq=product-5&orientation=squarish',
      rating: 4.6,
      sales: 768,
      tags: ['新品'],
      description: '精选金芽，清香回甘，生津持久'
    },
    {
      id: 6,
      name: '陈年老班章',
      category: '珍藏系列',
      price: 2888,
      originalPrice: 3280,
      image: 'https://readdy.ai/api/search-image?query=Aged%20Lao%20Ban%20Zhang%20pu-erh%20tea%2C%20premium%20vintage%20tea%20cake%20with%20natural%20aging%20patina%2C%20luxury%20tea%20presentation%2C%20traditional%20Chinese%20tea%20culture%2C%20sophisticated%20packaging%2C%20warm%20golden%20lighting%2C%20elegant%20background&width=400&height=400&seq=product-6&orientation=squarish',
      rating: 5.0,
      sales: 128,
      tags: ['珍藏', '限量'],
      description: '老班章产区陈年佳品，霸气回甘，茶中王者'
    },
    {
      id: 7,
      name: '宫廷级熟茶',
      category: '普洱熟茶',
      price: 388,
      originalPrice: 448,
      image: 'https://readdy.ai/api/search-image?query=Imperial%20grade%20pu-erh%20ripe%20tea%2C%20luxury%20palace-style%20tea%20packaging%2C%20premium%20dark%20fermented%20tea%20leaves%2C%20elegant%20presentation%2C%20traditional%20Chinese%20royal%20tea%20culture%2C%20warm%20lighting%2C%20sophisticated%20background&width=400&height=400&seq=product-7&orientation=squarish',
      rating: 4.7,
      sales: 634,
      tags: ['经典'],
      description: '宫廷级原料，醇厚顺滑，贵族品质'
    },
    {
      id: 8,
      name: '云南古树生茶',
      category: '普洱生茶',
      price: 758,
      originalPrice: 868,
      image: 'https://readdy.ai/api/search-image?query=Ancient%20tree%20pu-erh%20raw%20tea%20from%20Yunnan%20mountains%2C%20premium%20old%20tree%20tea%20leaves%2C%20traditional%20tea%20cake%20presentation%2C%20natural%20mountain%20tea%20culture%2C%20elegant%20packaging%2C%20warm%20lighting%2C%20simple%20clean%20background&width=400&height=400&seq=product-8&orientation=squarish',
      rating: 4.8,
      sales: 425,
      tags: ['古树'],
      description: '百年古树原料，山韵浓郁，自然甘甜'
    }
  ];

  const filteredProducts = activeCategory === '全部产品' 
    ? products 
    : products.filter(product => product.category === activeCategory);

  return (
    <section className="py-16 bg-gray-50" data-product-shop id="all-products-section">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#663333] mb-4">
            全部产品
          </h2>
          <p className="text-sm sm:text-lg max-w-2xl mx-auto text-gray-600">
            每一款茶品都经过精心挑选和专业制作，为您呈现最纯正的年份茶风味
          </p>
        </div>

        {/* 分类筛选和排序 - 移动优化 */}
        <div className="mb-8">
          {/* 移动端：分类和排序分行显示 */}
          <div className="lg:hidden space-y-4">
            {/* 分类筛选 */}
            <div>
              <div className="text-xs sm:text-sm text-gray-600 mb-2">产品分类：</div>
              <div className="flex flex-wrap gap-2">
                {categories.map((category) => (
                  <button
                    key={category}
                    onClick={() => setActiveCategory(category)}
                    className={`px-3 py-2 rounded-full text-xs sm:text-sm whitespace-nowrap transition-all duration-300 cursor-pointer ${
                      activeCategory === category
                        ? 'bg-[#cc9966] text-white'
                        : 'bg-white text-gray-600 hover:bg-[#cc9966] hover:text-white border border-gray-200'
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>
            
            {/* 排序选择 */}
            <div>
              <div className="text-xs sm:text-sm text-gray-600 mb-2">排序方式：</div>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="w-full bg-white border border-gray-200 rounded-lg px-3 py-2 text-xs sm:text-sm focus:outline-none focus:border-[#cc9966] cursor-pointer pr-8"
              >
                {sortOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* PC端：保持原有横排布局 */}
          <div className="hidden lg:flex flex-col lg:flex-row justify-between items-center gap-4">
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setActiveCategory(category)}
                  className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-all duration-300 cursor-pointer ${
                    activeCategory === category
                      ? 'bg-[#cc9966] text-white'
                      : 'bg-white text-gray-600 hover:bg-[#cc9966] hover:text-white border border-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-600">排序方式：</span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="bg-white border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#cc9966] cursor-pointer pr-8"
              >
                {sortOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* 产品网格 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-hidden relative"
              data-product-shop
            >
              {/* 标签 */}
              <div className="absolute top-3 left-3 z-10 flex flex-col gap-1">
                {product.isNew && (
                  <span className="bg-green-500 text-white text-xs px-2 py-1 rounded-full">
                    新品
                  </span>
                )}
                {product.isHot && (
                  <span className="bg-red-5 00 text-white text-xs px-2 py-1 rounded-full">
                    热销
                  </span>
                )}
              </div>

              <div className="aspect-square overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6">
                <div className="flex justify-between items-start mb-3">
                  <h3 className="text-sm sm:text-base lg:text-lg font-bold text-[#663333] line-clamp-2">
                    {product.name}
                  </h3>
                  <div className="bg-[#cc9966] text-white text-xs px-2 py-1 rounded-full whitespace-nowrap ml-2">
                    {product.sales}
                  </div>
                </div>
                
                <p className="text-xs sm:text-sm text-gray-600 mb-3 line-clamp-2">
                  {product.description}
                </p>

                {/* 评分 */}
                <div className="flex items-center mb-3">
                  <div className="flex text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <i 
                        key={i} 
                        className={`ri-star-${product.rating > i ? 'fill' : 'line'} text-sm`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-xs sm:text-sm text-gray-500 ml-2">{product.rating}</span>
                </div>

                {/* 价格 */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <span className="text-sm sm:text-base lg:text-lg font-bold text-[#cc9966]">
                      {product.price}
                    </span>
                    <span className="text-xs sm:text-sm text-gray-400 line-through ml-2">
                      {product.originalPrice}
                    </span>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center cursor-pointer hover:text-[#cc9966] transition-colors">
                    <i className="ri-heart-line text-lg"></i>
                  </div>
                </div>
                
                <div className="flex gap-2">
                  <Button 
                    variant="primary" 
                    size="sm"
                    className="flex-1 rounded-full bg-[#cc9966] hover:bg-[#bb8855] text-xs sm:text-sm"
                  >
                    立即购买
                  </Button>
                  <Button 
                    variant="outline" 
                    size="sm"
                    className="rounded-full border-[#cc9966] text-[#cc9966] hover:bg-[#cc9966] hover:text-white text-xs sm:text-sm"
                  >
                    详情
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 加载更多 */}
        <div className="text-center mt-12">
          <Button 
            variant="outline" 
            size="lg" 
            className="rounded-full border-[#cc9966] text-[#cc9966] hover:bg-[#cc9966] hover:text-white px-8 text-xs sm:text-sm"
          >
            加载更多产品
          </Button>
        </div>
      </div>
    </section>
  );
}
